module.exports = __webpack_public_path__ + "static/media/bannerLanding.36bacb66.svg";